const notificationsTypes = {
    SHOW_SUCCESS_NOTIFICATION: '[NOTIFICATION] SHOW_SUCCESS_NOTIFICATION',
    SHOW_FAILED_NOTIFICATION: '[NOTIFICATION] SHOW_FAILED_NOTIFICATION',
    SHOW_BATCH_RESULTS_NOTIFICATION: '[NOTIFICATION] SHOW_BATCH_RESULTS_NOTIFICATION',
};
export default notificationsTypes;
